
<aside [ngClass]="{'panel': true, 'left': align === 'left', 'right' : align === 'right'}"  *ngIf="opened" [class.fixed]="fixed"
[ngStyle]="s">
  <header>
    <div class="title">User Profile</div>
    <!-- style="color:rgb(195,212,47)" -->
    <a href="javascript:void(0);" style="color:rgb(195,212,47)" (click)="close()">
      <!--<i [ngClass]="{'fas' : true, 'fa-caret-left' :  align === 'left', 'fa-caret-right' : align === 'right'}"></i>-->
      <i class="fas fa-times"></i>
    </a>
  </header>
  <div class="panel-body">
    <ng-content select="[name=body]"></ng-content>
  </div>
</aside>